import { getStringSchema, getSelectSchema, getPercentSchema } from 'src/compass/shared/schemas';
import * as Yup from 'yup';

export const CMEAccountsSchema = Yup.object().shape({
  notes: getStringSchema(255, 'Notes').notRequired(),
  asOf: Yup.object().shape(
    {
      brokerId: getSelectSchema('Relationship Owner'),
      cmeCommScheduleId: getSelectSchema('Commission Schedule'),
      cmeAdditClearingId: getSelectSchema('Additional Clearing').notRequired(),
      sourceEmployeeId: Yup.mixed().when('sourceId', {
        is: (sourceId: any) => sourceId != null,
        then() {
          return getSelectSchema('', 'Required when "Type" is entered');
        },
        otherwise(schema) {
          return schema.notRequired();
        },
      }),
      sourceId: Yup.mixed().when('sourceEmployeeId', {
        is: (sourceEmployeeId: any) => sourceEmployeeId != null,
        then() {
          return getSelectSchema('', 'Required when "Source Employee" is entered');
        },
        otherwise(schema) {
          return schema.notRequired();
        },
      }),
      agreementEmployeeId: Yup.mixed().when('agreementPercent', {
        is: (agreementPercent: any) => agreementPercent != null,
        then() {
          return getSelectSchema('', 'Agreement Employee is required when Agreement% is entered.');
        },
        otherwise(schema) {
          return schema.notRequired();
        },
      }),
      agreementPercent: Yup.mixed().when('agreementEmployeeId', {
        is: (agreementEmployeeId: any) => agreementEmployeeId != null,
        then() {
          return getPercentSchema('Agreement%');
        },
        otherwise(schema) {
          return schema.notRequired().transform((value, originalValue) => {
            if (typeof originalValue === 'string' && originalValue.trim() === '') return null;
            return value;
          });
        },
      }),
    },
    [
      ['agreementEmployeeId', 'agreementPercent'],
      ['sourceId', 'sourceEmployeeId'],
    ]
  ),
});
